import type { GridSortDirection } from "@mui/x-data-grid/models/gridSortModel";
import type { GridLogicOperator } from "@mui/x-data-grid-pro";

export type UrlSortModel = Record<string, GridSortDirection>;

export type UrlState = {
  [ResourceListSearchParams.SortModel]?: UrlSortModel;
  [ResourceListSearchParams.Page]?: number;
  [ResourceListSearchParams.PageSize]?: number;
  [ResourceListSearchParams.NotAppliedFilterModel]?: UrlFilterModel;
  [ResourceListSearchParams.FilterModel]?: UrlFilterModel;
  [ResourceListSearchParams.FilterModelLogicOperator]?: GridLogicOperator;
  [ResourceListSearchParams.DataLoadingEnabledByForce]?: boolean;
};

export type UrlFilterModel = Record<
  string,
  {
    v: any;
    o: string;
  }
>;

export enum ResourceListSearchParams {
  SortModel = "s",
  Page = "page",
  PageSize = "pageSize",
  FilterModel = "f",
  NotAppliedFilterModel = "nf",
  FilterModelLogicOperator = "fl",
  Option = "option",
  DataLoadingEnabledByForce = "dataLoadingEnabledByForce",
}
